import { render, staticRenderFns } from "./TradingChart.vue?vue&type=template&id=d65cf056&scoped=true"
import script from "./TradingChart.vue?vue&type=script&lang=js"
export * from "./TradingChart.vue?vue&type=script&lang=js"
import style0 from "./TradingChart.vue?vue&type=style&index=0&id=d65cf056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65cf056",
  null
  
)

export default component.exports